import type { ToggleButtonProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

const COLORS = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
] as const;

const ToggleButton = (theme: Theme) => {
  const rootStyle = (ownerState: ToggleButtonProps) => {
    const standardColor = ownerState.color === 'standard';

    const defaultStyle = {
      ...(standardColor && {
        '&.Mui-selected': {
          borderColor: 'inherit',
        },
      }),
    };

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.color === color && {
        '&:hover': {
          backgroundColor: alpha(
            theme.palette[color].main,
            theme.palette.action.hoverOpacity
          ),
          borderColor: alpha(theme.palette[color].main, 0.48),
        },
        '&.Mui-selected': {
          borderColor: theme.palette[color].main,
        },
      }),
    }));

    const disabledState = {
      '&.Mui-disabled': {
        '&.Mui-selected': {
          backgroundColor: theme.palette.action.selected,
          borderColor: theme.palette.action.disabledBackground,
          color: theme.palette.action.disabled,
        },
      },
    };

    return [...colorStyle, defaultStyle, disabledState];
  };

  return {
    MuiToggleButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: ToggleButtonProps }) =>
          rootStyle(ownerState),
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        grouped: {
          borderColor: 'transparent !important',
          borderRadius: `${theme.shape.borderRadius}px !important`,
          margin: 4,
        },
        root: {
          backgroundColor: theme.palette.background.paper,
          border: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
          borderRadius: theme.shape.borderRadius,
        },
      },
    },
  };
};

export default ToggleButton;
